import React from 'react';

// Hooks
import { useState } from 'react';

// Interfaces
import { Location } from '../interfaces/Location';
import { IColumnOrder } from '../interfaces/UtilInterfaces';

// GeneralContext. Stores general context.
const GeneralContext = React.createContext<{
    openSidebar: boolean, setOpenSidebar: React.Dispatch<React.SetStateAction<boolean>>,
    accessToken: string, setAccessToken: React.Dispatch<React.SetStateAction<string>>,
    firebaseToken: string, setFirebaseToken: React.Dispatch<React.SetStateAction<string>>,
    hospitalToken: string, setHospitalToken: React.Dispatch<React.SetStateAction<string>>,
    GOOGLE_API_KEY: string, setGOOGLE_API_KEY: React.Dispatch<React.SetStateAction<string>>,
    hospitalLocation: Location, setHospitalLocation: React.Dispatch<React.SetStateAction<Location>>,
    viewSonar: boolean, setViewSonar: React.Dispatch<React.SetStateAction<boolean>>,
    patientsTableColumnOrder: IColumnOrder, setPatientsTableColumnOrder: React.Dispatch<React.SetStateAction<IColumnOrder>>,
    SONARTableColumnOrder: IColumnOrder, setSONARTableColumnOrder: React.Dispatch<React.SetStateAction<IColumnOrder>>,
    isChatOpen?: boolean, setIsChatOpen?: React.Dispatch<React.SetStateAction<boolean>>,
}
>({
    openSidebar: true, setOpenSidebar: () => undefined,
    accessToken: '', setAccessToken: () => undefined,
    firebaseToken: '', setFirebaseToken: () => undefined,
    hospitalToken: '', setHospitalToken: () => undefined,
    GOOGLE_API_KEY: '', setGOOGLE_API_KEY: () => undefined,
    hospitalLocation: { lat: 0, lng: 0 }, setHospitalLocation: () => undefined,
    viewSonar: false, setViewSonar: () => undefined,
    patientsTableColumnOrder: { col: 0, asc: true }, setPatientsTableColumnOrder: () => undefined,
    SONARTableColumnOrder: { col: 0, asc: true }, setSONARTableColumnOrder: () => undefined,
    isChatOpen: false, setIsChatOpen: () => undefined,
});

export const GeneralContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    // handles whether the sidebar is displayed.
    const [openSidebar, setOpenSidebar] = useState<boolean>(window.innerWidth >= 1200);

    // Access token
    const [accessToken, setAccessToken] = useState<string>('');
    
    // Access token
    const [firebaseToken, setFirebaseToken] = useState<string>('');
    
    // Access token
    const [hospitalToken, setHospitalToken] = useState<string>('');

    // API KEY de GOOGLE
    const [GOOGLE_API_KEY, setGOOGLE_API_KEY] = useState<string>('');

    // location of the hospital
    const [hospitalLocation, setHospitalLocation] = useState<Location>({ lat: 0, lng: 0 });

    // sonar view active
    const [viewSonar, setViewSonar] = useState<boolean>(false);

    // patientsTableColumnToOrderBy
    const [patientsTableColumnOrder, setPatientsTableColumnOrder] = useState<IColumnOrder>({ col: 0, asc: true });

    // patients SONAR Column To Order By
    const [SONARTableColumnOrder, setSONARTableColumnOrder] = useState<IColumnOrder>({ col: 0, asc: true });

    // isChatOpen
    const [isChatOpen, setIsChatOpen] = useState<boolean>(false);

    const initState = {
        openSidebar, setOpenSidebar,
        accessToken, setAccessToken,
        firebaseToken, setFirebaseToken,
        hospitalToken, setHospitalToken,
        GOOGLE_API_KEY, setGOOGLE_API_KEY,
        hospitalLocation, setHospitalLocation,
        viewSonar, setViewSonar,
        patientsTableColumnOrder, setPatientsTableColumnOrder,
        SONARTableColumnOrder, setSONARTableColumnOrder,
        isChatOpen, setIsChatOpen,
    };

    return (
        <GeneralContext.Provider value={initState}>
            {children}
        </GeneralContext.Provider>
    );
};
export default GeneralContext;
